import cx from 'clsx';
import * as React from 'react';

import { CarouselSlider } from '@/components/Carousel';
import { useWindowSize } from '@/hooks/useWindowSize';

import styles from './Subheader.module.scss';
import SubheaderSlot from './SubheaderSlot';
import { SubheaderProps } from './types';

const Subheader: React.FC<SubheaderProps> = ({
  items,
  onClick,
  navHorizontalPadding = 0,
  background = 'white',
  initialScroll,
  isSubNavigation,
  deviceType,
}) => {
  const subhederElement: any = React.useRef();
  const handleItemClick = (
    e: React.MouseEvent<{}>,
    index: number,
    type: string,
    title: string
  ) => {
    e.preventDefault();
    onClick({ index, type, title });
  };
  const [shouldBeArrowSlider, setShouldBeArrowSlider] = React.useState<boolean>(
    false
  );
  const windowWidth = useWindowSize().width;

  React.useEffect(() => {
    if (!isSubNavigation && !items.length) return;
    const { width } = subhederElement.current.getBoundingClientRect();
    if (
      width <= items.length * 105 &&
      !isSubNavigation &&
      deviceType === 'desktop'
    ) {
      setShouldBeArrowSlider(true);
    } else {
      setShouldBeArrowSlider(false);
    }
  }, [windowWidth, items, isSubNavigation, deviceType]);

  if (!isSubNavigation && !items.length) return null;

  return (
    <div
      className={cx(
        `${styles[`wrapper__${navHorizontalPadding}`]}`,
        deviceType === 'desktop' && styles.desktop
      )}
      style={{ backgroundColor: background }}
      data-testid="subheader-wrapper"
      ref={subhederElement}
    >
      <CarouselSlider
        styleProp={shouldBeArrowSlider ? 'arrowSlider' : 'slider'}
        edgeSlidesPadding={navHorizontalPadding}
        initialScroll={initialScroll}
      >
        {items.map((item, index) => (
          <div
            className={styles.slot}
            key={index}
            data-testid={`${index}-slot`}
          >
            <SubheaderSlot
              data-testid={'subheader-slot'}
              item={item}
              onClick={e => handleItemClick(e, index, item.type, item.title)}
            />
          </div>
        ))}
      </CarouselSlider>
    </div>
  );
};

export default Subheader;
